import * as z from 'zod/mini';

export const LoginRequestSchema = z.object({
  email: z.string(),
  package_id: z.string(),
  locale: z.string(),
  office_id: z.number(),
  department_id: z.number(),
});

export const LoginResponseSchema = z.object({
  message: z.string(),
  token: z.string(),
});
